import { render, staticRenderFns } from "./ActivePhds.vue?vue&type=template&id=7fa0e14c&scoped=true&"
import script from "./ActivePhds.vue?vue&type=script&lang=js&"
export * from "./ActivePhds.vue?vue&type=script&lang=js&"
import style0 from "./ActivePhds.vue?vue&type=style&index=0&id=7fa0e14c&prod&lang=css&"
import style1 from "./ActivePhds.vue?vue&type=style&index=1&id=7fa0e14c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa0e14c",
  null
  
)

export default component.exports